import { CreateAccountContentView } from "./CreateAccountContentView"

/** A tela de cadastro de usuário */
const CreateAccountView = () => {
	return (
		<>
			<CreateAccountContentView />
		</>
	)
}

export default CreateAccountView
